import { render, staticRenderFns } from "./order_online_extra.vue?vue&type=template&id=698cf1e6&scoped=true"
import script from "./order_online_extra.vue?vue&type=script&lang=js"
export * from "./order_online_extra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698cf1e6",
  null
  
)

export default component.exports